import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENTS_PREVIEW_ROUTE } from '../../../document-data/document-data.data';
import { DocumentPreview } from '../../../document-data/sub-models/document-preview.model';
import { UtilsService } from '../../services/utils/utils.service';
import {
  ITrackingAction,
  ITrackingObject,
} from '../../../tracking/tracking.data';

@Component({
  selector: 'app-document-link',
  templateUrl: './document-link.component.html',
  styleUrls: ['./document-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentLinkComponent implements OnInit, OnChanges {
  @Input() documentPreview: DocumentPreview;
  @Input() labelKey: string;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  label: string;
  route: string[];

  constructor(
    private _utilsService: UtilsService,
    private _translateService: TranslateService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.documentPreview && this.documentPreview) {
      this.label = this._translateService.instant(
        `DOCUMENT.${this.documentPreview.documentType}.LINK.${this.labelKey}`.toUpperCase(),
        { documentNumber: this.documentPreview.docNumber }
      );
      this.route = [
        this._utilsService.getDocumentMasterRoute(
          this.documentPreview.documentType
        ),
        this.documentPreview.id,
        DOCUMENTS_PREVIEW_ROUTE,
      ];
    }
  }

  ngOnInit() {}
}
